
import { Component, Mixins } from "vue-property-decorator";
import { Size, Point, Rectangle } from "../../../../domain/drawing";
import { Section } from "../../../../domain/document";
import { IItem, instanceOfIDrawable, PositionCorrectItem, NewPageItem } from "../../../../domain/document/items";

interface INewPagePositionInformation {
  position: number;
  isNewPageObjectPosition: boolean;
}

@Component({
})
export default class EditingDocumentDrawableMixin extends Mixins() {
  currentSection: Section;
  currentSectionItems: IItem[];

  get currentPageSizeStyle(): any {
    return {
      width: this.currentSectionSize.width + "px",
      height: this.calculateCurrentSectionDisplayHeight() + "px"
    };
  }

  get calculatedPageSize(): Size {
    // TODO: refactor
    // 検証に余裕のあるタイミングでcurrentPageSizeStyleと共通化したいところではある
    return new Size(this.currentSectionSize.width, this.calculateCurrentSectionDisplayHeight());
  }

  calculateCurrentSectionDisplayHeight(): number {
    if (!this.isPageSplittable) {
      return this.currentSectionSize.height;
    }
    // 可変対応のためオブジェクトが見えるところまで白塗りの表示を伸ばしている
    const contentsHeight = this.getContentsMaxHeight();
    return (this.currentSectionSize.height > contentsHeight)
      ? this.currentSectionSize.height
      : contentsHeight + 10;   // V1のWebEditorを見る限りでは、多少の余白を付与している
  }

  get isPageSplittable(): boolean {
    return this.currentSection
        && this.currentSection.isPageSplittable;
  }

  get splitRedundantMargin(): number {
    return this.currentSection ? this.currentSection.splitRedundantMargin : 0;
  }

  private getContentsMaxHeight(): number {
    let max = 0;
    for (const item of this.currentSectionItems) {
      if (!item || !instanceOfIDrawable(item) || item instanceof PositionCorrectItem) { continue; }
      const contentRect = item.geometry.rectangle;
      const contentHeight = contentRect.y + contentRect.height;
      max = (max > contentHeight) ? max : contentHeight;
    }
    return max;
  }

  get pageBorderLinePositions(): number[] {
    if (!this.isPageSplittable) {
      return [];
    }
    const currentSectionHeight = this.currentSectionSize.height;
    if (!currentSectionHeight) { return []; }
    const contentMaxHeight = this.getContentsMaxHeight();
    const positions: number[] = [];
    let currentPosition = 0;
    while (true) {
      // 文字が切れないようにする補正の影響で分割2ページ目以降の余白が足りなくなる現象が発生する
      // その対策で分割2ページ目以降に余白を追加すると、改ページ位置がPDFとフロントエンドの表示とでずれてしまうので対策している
      const bottomMargin = (!!currentPosition && (this.splitRedundantMargin != null) && isFinite(this.splitRedundantMargin))
        ? this.splitRedundantMargin
        : 0;
      const limitPosition = currentPosition + currentSectionHeight - bottomMargin;
      const info = this.calculateNewPagePosition(currentPosition, limitPosition);
      if (contentMaxHeight <= info.position) { break; }
      if (!info.isNewPageObjectPosition) {
        // 改ページオブジェクトの上にはページ区切りは描画不要
        positions.push(info.position);
      }
      currentPosition = info.position;
    }
    return positions;
  }

  /**
   * 指定されたY座標の範囲内に改ページオブジェクトがある場合は、そのオブジェクトのY座標を返却する（複数ある場合は小さいほうの値）
   */
  calculateNewPagePosition(from: number, to: number): INewPagePositionInformation {
    let minimum = to;
    let isNewPageObjectPosition = false;
    for (const item of this.currentSectionItems) {
      if (!item || !(item instanceof NewPageItem)) { continue; }
      const y = item.geometry.rectangle.topLeft.y;
      if (from < y && to >= y) {
        minimum = (!minimum || minimum > y) ? y : minimum;
        isNewPageObjectPosition = true;
      }
    }
    return {
      position: minimum,
      isNewPageObjectPosition,
    };
  }

  get currentSectionSize(): Size {
    // v1同様にヘッダ/フッタを除いたサイズを利用する.
    return (!this.currentSection || !this.currentSection.bodyRectangle.size)
      ? new Size(0, 0)
      : this.currentSection.bodyRectangle.size;
  }

  get isCurrentSectionLandscape(): boolean {
    return !!this.currentSection && this.currentSection.landscape;
  }

  get layerImageRectangleStyle(): any {
    return {
      left: this.layerImageRectangle.x + "px",
      top: this.layerImageRectangle.y + "px",
      width: this.layerImageRectangle.width + "px",
      height: this.layerImageRectangle.height + "px"
    };
  }

  get layerImageRectangle(): Rectangle {
    return (!this.currentSection || !this.currentSection.layerImageRectangle)
      ? new Rectangle(new Point(0, 0), new Size(0, 0))
      : this.currentSection.layerImageRectangle;
  }

  get layerImageSource(): any {
    return !this.currentSection
      ? ""
      : this.currentSection.layerImageSource.source;
  }
}
